import axios from '../../../helpers/AxiosConfig';
import { PaginationResponse } from '../types';
import { DataSourceObj, ProcessDataSourceQueryResponse } from './dataSource.types';

export const processDataSourceQuery = async (data: DataSourceObj) => {
  return axios.post<ProcessDataSourceQueryResponse>('/dataSources/processQuery', data);
};

export const addDataSource = async (data: DataSourceObj) => {
  return axios.post<DataSourceObj>('/dataSources', data);
};
export const getDataSource = async (params: DataSourceObj) => {
  return axios.get<PaginationResponse<DataSourceObj>>('/dataSources', {
    params,
  });
};

export const updateDataSource = async (data: DataSourceObj) => {
  const { id, ...formData } = data;
  return axios.patch<DataSourceObj>(`/dataSources/${id}`, formData);
};
